import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Linkedin, Instagram, Mail, Phone, Heart } from 'lucide-react';

const Footer = () => {
  const quickLinks = [
    { name: 'Shipping & Returns', path: '/shipping' },
    { name: 'FAQs', path: '/faq' },
    { name: 'Privacy Policy', path: '/privacy' },
    { name: 'Terms of Service', path: '/terms' }
  ];

  const categories = [
    { name: 'Mobility Aids', path: '/products?category=mobility-aids' },
    { name: 'Bath Safety', path: '/products?category=bath-safety' },
    { name: 'Daily Living', path: '/products?category=daily-living' },
    { name: 'Incontinence', path: '/products?category=incontinence' }
  ];

  return (
    <footer className="bg-[#1e3a5f] text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Logo and About */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_healthcare-products/artifacts/0o4r6g9q_6F5E6702-51DA-435B-9CBD-CA2B0831C7B9.png"
                alt="Kalorama Medical Logo"
                className="h-12 w-12 object-contain"
              />
              <div>
                <div className="text-lg font-bold">KALORAMA MEDICAL</div>
                <div className="text-xs text-blue-200">Innovating Health. Connecting Care</div>
              </div>
            </div>
            <p className="text-blue-200 text-sm mb-4">
              Your trusted partner for quality durable medical equipment and exceptional customer service.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-blue-200 hover:text-white transition-colors duration-200">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="text-blue-200 hover:text-white transition-colors duration-200">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="#" className="text-blue-200 hover:text-white transition-colors duration-200">
                <Linkedin className="h-5 w-5" />
              </a>
              <a href="#" className="text-blue-200 hover:text-white transition-colors duration-200">
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-blue-200 hover:text-white transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Product Categories */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Product Categories</h3>
            <ul className="space-y-2">
              {categories.map((category) => (
                <li key={category.path}>
                  <Link
                    to={category.path}
                    className="text-blue-200 hover:text-white transition-colors duration-200 text-sm"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2 text-sm">
                <Mail className="h-4 w-4 mt-0.5 text-[#7bb5d4]" />
                <a href="mailto:info@kaloramamedical.com" className="text-blue-200 hover:text-white transition-colors duration-200">
                  info@kaloramamedical.com
                </a>
              </li>
              <li className="flex items-start space-x-2 text-sm">
                <Phone className="h-4 w-4 mt-0.5 text-[#7bb5d4]" />
                <a href="tel:2403558003" className="text-blue-200 hover:text-white transition-colors duration-200">
                  (240) 355-8003
                </a>
              </li>
              <li className="text-blue-200 text-sm mt-4">
                For inquiries, please use our contact form.
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-blue-800 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-blue-200 text-sm mb-4 md:mb-0">
              © 2026 Kalorama Medical. All rights reserved.
            </p>
            <p className="text-blue-200 text-sm flex items-center">
              Made with <Heart className="h-4 w-4 mx-1 fill-[#7bb5d4] text-[#7bb5d4]" /> for better healthcare
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
